import { Account, Note } from "common";
import { useMemo } from "react";

export const useNoteAccount = (note: Note): Omit<Account, "roles"> | null => {
  return useMemo(() => note.accounts[0] ?? null, [note.accounts]);
};
